import React, {ImgHTMLAttributes} from 'react';
import {PopupProps} from 'reactjs-popup/dist/types';
import {theme} from '../../styled/theme';
import {useLockScrollBody} from 'hooks';
import CustomIcon from '../common/CustomIcon';
import {IconWrapper, Title, Text, CloseButton, ModalStyled} from './styled';

export type ModalProps = Omit<PopupProps, 'children'> & {
  children?: React.ReactNode;
  zIndex?: number;
  iconSrc?: string;
  iconAlt?: string;
  iconElement?: React.ReactNode | JSX.Element;
  title?: string | React.ReactNode | JSX.Element;
  text?: string | React.ReactNode | JSX.Element;
  iconProps?: ImgHTMLAttributes<HTMLImageElement>;
  withCloseButton?: boolean;
  maxWidth?: string;
  width?: string | number;
  isConnectionIssue?: boolean;
  padding?: boolean;
};

const defaultProps = {
  open: false,
  closeOnDocumentClick: false,
  closeOnEscape: false,
  zIndex: 100,
  iconSrc: '',
  iconAlt: undefined,
  title: '',
  text: '',
  children: null,
  lockScroll: true,
  iconProps: {},
  withCloseButton: false,
  maxWidth: '500px',
  width: 'auto',
  isConnectionIssue: false,
};

const ErrorSvgIcon = () => (
  <svg width="180" height="180" viewBox="0 0 230 229">
    <g clip-path="url(#clip0_6645_192886)">
      <path
        d="M116.046 220.358C167.77 220.358 209.701 174.357 209.701 117.612C209.701 60.8678 167.77 14.8672 116.046 14.8672C64.3215 14.8672 22.3906 60.8678 22.3906 117.612C22.3906 174.357 64.3215 220.358 116.046 220.358Z"
        fill="url(#paint0_linear_6645_192886)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M187.168 52.7539C188.824 48.5477 189.315 44.3491 190.035 39.954C190.176 39.0956 189.593 38.2882 188.734 38.1468C187.876 38.0053 187.065 38.5889 186.924 39.4472C186.241 43.6148 185.806 47.6095 184.234 51.6051C183.916 52.4132 184.315 53.3281 185.125 53.6427C185.934 53.9625 186.85 53.5621 187.168 52.7539Z"
        fill="#ADAEE6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M195.16 62.4034C203.329 56.7449 211.332 49.1302 217.281 41.1556C217.8 40.4589 217.655 39.4724 216.956 38.9561C216.258 38.4398 215.27 38.5822 214.751 39.2788C208.999 46.9891 201.259 54.3539 193.361 59.8214C192.647 60.3175 192.47 61.2979 192.967 62.0091C193.464 62.7204 194.446 62.8996 195.16 62.4034Z"
        fill="#ADAEE6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M196.032 69.9008C202.543 71.8884 209.656 70.9395 216.065 69.1086C216.901 68.8667 217.384 67.9962 217.144 67.1661C216.904 66.3307 216.03 65.8489 215.195 66.0856C209.358 67.7553 202.883 68.7053 196.953 66.8959C196.121 66.6417 195.239 67.1101 194.986 67.9375C194.732 68.7648 195.201 69.6467 196.032 69.9008Z"
        fill="#ADAEE6"
      />
      <path
        d="M40.9733 170.117C41.4033 170.374 41.5419 170.931 41.2822 171.359L40.9733 170.117ZM40.9733 170.117L41.2314 169.689C37.7071 167.565 35.3106 164.6 34.0449 160.688L34.0448 160.688M40.9733 170.117L41.2295 169.688C41.898 170.087 42.1132 170.953 41.7098 171.618L41.7094 171.619C41.308 172.279 40.4412 172.494 39.7758 172.091C35.6622 169.612 32.8454 166.123 31.3634 161.546L34.0448 160.688M34.0448 160.688C33.8061 159.951 33.0135 159.544 32.2735 159.78M34.0448 160.688L32.2735 159.78M32.2735 159.78C31.5325 160.014 31.1239 160.807 31.3633 161.546L32.2735 159.78Z"
        fill="#3435A2"
        stroke="#3D3DAB"
      />
      <path
        d="M31.5725 211.614L31.5728 211.614C32.379 210.717 32.5864 209.812 32.4175 208.996C32.2575 208.22 31.7385 207.553 31.0225 207.043L31.0223 207.043C30.3392 206.557 29.44 206.198 28.5697 205.954C27.8092 205.74 27.0403 205.606 26.4064 205.558C25.9227 204.729 25.511 203.858 25.173 202.958C22.4617 195.735 26.3979 187.123 34.9154 181.854C36.3218 180.984 38.297 180.553 40.6482 180.45C42.9907 180.347 45.6537 180.571 48.3953 180.968L48.3953 180.968C55.8203 182.041 63.6728 184.461 67.3875 185.605C67.945 185.777 68.4094 185.92 68.7651 186.026L68.7661 186.026C69.117 186.129 69.4073 186.194 69.6274 186.231C69.7371 186.25 69.8326 186.262 69.9116 186.269C69.9743 186.274 70.0663 186.28 70.1509 186.268C70.8136 186.176 71.1058 185.75 71.2387 185.474L71.2387 185.474L71.241 185.469C71.4227 185.081 71.4351 184.718 71.3648 184.405L71.3641 184.402C71.2652 183.973 70.9954 183.584 70.5363 183.321L70.5331 183.319C70.2817 183.177 69.9476 183.076 69.6357 183L69.6307 182.999C69.566 182.984 69.502 182.972 69.4468 182.962C69.388 182.952 69.3422 182.944 69.297 182.934C69.2109 182.917 69.1834 182.905 69.1831 182.906C69.1831 182.906 69.1833 182.906 69.1836 182.906C68.4254 182.454 67.6952 181.964 66.9503 181.465C66.8413 181.392 66.7321 181.319 66.6224 181.246L66.6215 181.245C63.7736 179.35 61.1998 177.192 58.6588 174.872L58.6588 174.872C57.9762 174.249 57.2903 173.626 56.6035 173.003C49.1101 166.202 41.5149 159.309 36.953 150.301L36.9529 150.301C36.6037 149.612 35.759 149.328 35.0631 149.676C34.3654 150.022 34.0891 150.868 34.437 151.562L34.4378 151.563C39.2175 161.004 47.1635 168.223 54.8355 175.193C55.4787 175.777 56.12 176.36 56.7574 176.942L56.7574 176.942C58.2741 178.326 59.8104 179.662 61.412 180.926C57.0972 179.748 51.7935 178.495 46.8441 177.935C44.1805 177.633 41.6044 177.541 39.3127 177.758C37.0265 177.975 34.9875 178.502 33.4263 179.467L33.4262 179.467C23.8279 185.405 19.3293 195.404 22.5343 203.938L22.5344 203.938C22.7996 204.643 23.1038 205.336 23.4472 206.009C16.012 208.166 11.4328 215.29 12.7646 223.034C12.8958 223.803 13.6256 224.313 14.3878 224.186L14.3878 224.186L14.3911 224.186C15.1548 224.054 15.6734 223.333 15.5423 222.565L15.5422 222.564C14.4149 216.008 18.4801 210.013 24.9773 208.515C25.5675 209.329 26.2258 210.099 26.9521 210.806C27.3149 211.159 28.1402 211.858 28.9734 212.157C29.8864 212.487 30.8633 212.403 31.5725 211.614Z"
        fill="#3D3EAB"
        stroke="#3C3DAA"
      />
      <path
        d="M100.453 55.5245C100.046 53.8356 97.6432 53.8356 97.2355 55.5245L96.7074 57.7122C96.5617 58.3158 96.0904 58.787 95.4869 58.9327L93.2992 59.4608C91.6102 59.8685 91.6102 62.2709 93.2992 62.6786L95.4869 63.2067C96.0904 63.3524 96.5617 63.8236 96.7074 64.4272L97.2355 66.6149C97.6432 68.3039 100.046 68.3039 100.453 66.6149L100.981 64.4272C101.127 63.8236 101.598 63.3524 102.202 63.2067L104.39 62.6786C106.078 62.2709 106.078 59.8685 104.39 59.4608L102.202 58.9327C101.598 58.787 101.127 58.3158 100.981 57.7122L100.453 55.5245Z"
        fill="#CCC6D9"
      />
      <circle cx="170.922" cy="171.742" r="3.7265" stroke="#3435A2" stroke-width="2" />
      <path
        d="M80.4394 110.191C81.634 101.244 85.0682 92.7457 90.4215 85.4898C95.7748 78.2338 102.873 72.4563 111.053 68.6963C119.234 64.9363 128.231 63.3163 137.204 63.9874C146.177 64.6584 154.835 67.5987 162.37 72.534L182.898 65.5329C183.517 65.3282 184.182 65.3056 184.813 65.4679C185.445 65.6302 186.017 65.9706 186.462 66.4488C186.907 66.927 187.206 67.523 187.324 68.1663C187.442 68.8096 187.373 69.4734 187.127 70.079L178.895 89.7789C183.273 97.0964 185.841 105.36 186.382 113.877C186.924 122.394 185.424 130.917 182.008 138.734C178.592 146.55 173.36 153.432 166.748 158.803C160.137 164.174 152.34 167.878 144.009 169.605C135.677 171.332 127.055 171.033 118.863 168.73C110.671 166.428 103.148 162.191 96.924 156.374C90.6996 150.556 85.9548 143.327 83.0867 135.292C80.2187 127.257 79.311 118.65 80.4394 110.191Z"
        fill="#3435A2"
      />
      <path
        d="M45.3535 134.075C46.5481 143.022 49.9822 151.52 55.3356 158.776C60.6889 166.032 67.7869 171.809 75.9675 175.569C84.1481 179.329 93.1447 180.949 102.118 180.278C111.092 179.607 119.749 176.667 127.284 171.732L147.812 178.733C148.431 178.937 149.096 178.96 149.727 178.798C150.359 178.635 150.931 178.295 151.376 177.817C151.821 177.339 152.12 176.743 152.238 176.099C152.356 175.456 152.287 174.792 152.041 174.187L143.809 154.487C148.187 147.169 150.755 138.906 151.296 130.389C151.838 121.872 150.338 113.348 146.922 105.532C143.506 97.7156 138.274 90.8339 131.662 85.4629C125.051 80.0918 117.254 76.3876 108.923 74.6604C100.592 72.9331 91.9692 73.2331 83.7774 75.5352C75.5855 77.8372 68.0625 82.0744 61.8381 87.892C55.6136 93.7096 50.8688 100.938 48.0008 108.973C45.1328 117.008 44.225 125.615 45.3535 134.075Z"
        fill="#ADAEE6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.5038 142.648C88.5038 135.867 93.4742 130.907 98.971 130.907C104.468 130.907 109.438 135.867 109.438 142.648H116.528C116.528 132.545 108.951 123.818 98.971 123.818C88.9906 123.818 81.4141 132.545 81.4141 142.648H88.5038Z"
        fill="white"
      />
      <path
        d="M79.8613 123.535C83.3789 123.535 86.2304 120.684 86.2304 117.166C86.2304 113.648 83.3789 110.797 79.8613 110.797C76.3437 110.797 73.4922 113.648 73.4922 117.166C73.4922 120.684 76.3437 123.535 79.8613 123.535Z"
        fill="white"
      />
      <path
        d="M118.08 123.535C121.598 123.535 124.449 120.684 124.449 117.166C124.449 113.648 121.598 110.797 118.08 110.797C114.562 110.797 111.711 113.648 111.711 117.166C111.711 120.684 114.562 123.535 118.08 123.535Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6645_192886"
        x1="115.324"
        y1="-18.5892"
        x2="117.633"
        y2="342.234"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F2F2F2" />
        <stop offset="1" stop-color="#EFEFEF" />
      </linearGradient>
      <clipPath id="clip0_6645_192886">
        <rect width="230" height="229" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

function Modal({
  open,
  onClose,
  children,
  closeOnDocumentClick,
  closeOnEscape,
  zIndex,
  maxWidth,
  iconAlt,
  iconSrc,
  title,
  text,
  lockScroll,
  iconProps,
  withCloseButton,
  width,
  isConnectionIssue,
  iconElement,
  padding,
  ...props
}: ModalProps) {
  const {lockScroll: lockScrollOnClose} = useLockScrollBody(true);
  const onCloseModal = () => {
    lockScrollOnClose();
    onClose?.();
  };
  return (
    <ModalStyled
      open={open}
      onClose={onCloseModal}
      closeOnDocumentClick={closeOnDocumentClick}
      closeOnEscape={closeOnEscape}
      lockScroll={lockScroll}
      maxWidth={maxWidth}
      width={width}
      padding={padding}
      {...props}
    >
      <>
        {withCloseButton && (
          <CloseButton onClick={onClose}>
            <CustomIcon size={12} color={theme.colors.$p0} name={'close'} />
          </CloseButton>
        )}
        {(iconElement || iconSrc || iconProps?.src) && (
          <IconWrapper className="modal__icon">
            {isConnectionIssue && <ErrorSvgIcon />}
            {iconElement}
            {!isConnectionIssue && <img src={iconSrc} alt={iconAlt} {...iconProps} />}
          </IconWrapper>
        )}
        {title && <Title className="modal__title">{title}</Title>}
        {text && <Text className="modal__description">{text}</Text>}
        {children}
      </>
    </ModalStyled>
  );
}

Modal.defaultProps = defaultProps;
export {Modal};
